"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPaymentBodyDto = void 0;
class OrderPaymentBodyDto {
}
exports.OrderPaymentBodyDto = OrderPaymentBodyDto;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JkZXJQYXltZW50Qm9keUR0by5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9kdG8vb3JkZXJQYXltZW50Qm9keUR0by50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLG1CQUFtQjtDQUcvQjtBQUhELGtEQUdDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIE9yZGVyUGF5bWVudEJvZHlEdG97XG4gICAgaWQ6IG51bWJlcjtcbiAgICBhbW91bnQ6IG51bWJlcjtcbn0iXX0=